import item1 from '../../assets/shape/fittestcities1open.jpg'
import item2 from '../../assets/shape/fittestcities2.jpg'
import item3 from '../../assets/shape/fittestcities3.jpg'
import item6 from '../../assets/shape/hotlist.jpg'
import item4 from '../../assets/shape/lightenlunch1.jpg'
import item5 from '../../assets/shape/lightenlunch2.jpg'
import item7 from '../../assets/shape/cancerfood1.jpg'
import item8 from '../../assets/shape/cancerfood2.jpg'
import item10 from '../../assets/shape/agefeat1.jpg'
import item11 from '../../assets/shape/agefeat2.jpg'
import item9 from '../../assets/shape/7blgbeautynews.jpg'

export const items = [
  {
    image: item1,
  },
  {
    image: item2,
  },
  {
    image: item3,
  },
  {
    image: item4,
  },
  {
    image: item5,
  },
  {
    image: item6,
  },
  {
    image: item7,
  },
  {
    image: item8,
  },
  {
    image: item9,
  },
  {
    image: item10,
  },
  {
    image: item11,
  },
]

//
